"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const simple_websocket_reader_1 = require("./simple-websocket-reader");
const url_1 = require("url");
const http_1 = require("http");
const https_1 = require("https");
/** class simply implements Net interface */
class SimpleNet {
    constructor(baseURL, timeout = 15 * 1000, wsTimeout = 30 * 1000) {
        this.baseURL = baseURL;
        this.wsTimeout = wsTimeout;
        this.axios = axios_1.default.create({
            httpAgent: new http_1.Agent({ keepAlive: true }),
            httpsAgent: new https_1.Agent({ keepAlive: true }),
            baseURL,
            timeout
        });
    }
    http(method, path, params) {
        return __awaiter(this, void 0, void 0, function* () {
            params = params || {};
            try {
                const resp = yield this.axios.request({
                    method,
                    url: path,
                    data: params.body ? JSON.stringify(params.body) : undefined,
                    headers: params.headers,
                    params: params.query
                });
                if (params.validateResponseHeader) {
                    params.validateResponseHeader(resp.headers);
                }
                return resp.data;
            }
            catch (err) {
                if (err.isAxiosError) {
                    throw convertError(err);
                }
                throw new Error(`${method} ${url_1.resolve(this.baseURL, path)}: ${err.message}`);
            }
        });
    }
    openWebSocketReader(path) {
        const url = url_1.resolve(this.baseURL, path)
            .replace(/^http:/i, 'ws:')
            .replace(/^https:/i, 'wss:');
        return new simple_websocket_reader_1.SimpleWebSocketReader(url, this.wsTimeout);
    }
}
exports.SimpleNet = SimpleNet;
function convertError(err) {
    if (err.response) {
        const resp = err.response;
        if (typeof resp.data === 'string') {
            let text = resp.data.trim();
            if (text.length > 50) {
                text = text.slice(0, 50) + '...';
            }
            return new Error(`${resp.status} ${err.config.method} ${err.config.url}: ${text}`);
        }
        else {
            return new Error(`${resp.status} ${err.config.method} ${err.config.url}`);
        }
    }
    else {
        return new Error(`${err.config.method} ${err.config.url}: ${err.message}`);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2ltcGxlLW5ldC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zaW1wbGUtbmV0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQ0EsaUNBQXdEO0FBQ3hELHVFQUFpRTtBQUNqRSw2QkFBNkI7QUFDN0IsK0JBQXlDO0FBQ3pDLGlDQUEyQztBQUUzQyw0Q0FBNEM7QUFDNUMsTUFBYSxTQUFTO0lBR2xCLFlBQ2EsT0FBZSxFQUN4QixPQUFPLEdBQUcsRUFBRSxHQUFHLElBQUksRUFDRixZQUFZLEVBQUUsR0FBRyxJQUFJO1FBRjdCLFlBQU8sR0FBUCxPQUFPLENBQVE7UUFFUCxjQUFTLEdBQVQsU0FBUyxDQUFZO1FBRXRDLElBQUksQ0FBQyxLQUFLLEdBQUcsZUFBSyxDQUFDLE1BQU0sQ0FBQztZQUN0QixTQUFTLEVBQUUsSUFBSSxZQUFTLENBQUMsRUFBRSxTQUFTLEVBQUUsSUFBSSxFQUFFLENBQUM7WUFDN0MsVUFBVSxFQUFFLElBQUksYUFBVSxDQUFDLEVBQUUsU0FBUyxFQUFFLElBQUksRUFBRSxDQUFDO1lBQy9DLE9BQU87WUFDUCxPQUFPO1NBQ1YsQ0FBQyxDQUFBO0lBQ04sQ0FBQztJQUVZLElBQUksQ0FDYixNQUFzQixFQUN0QixJQUFZLEVBQ1osTUFBbUI7O1lBQ25CLE1BQU0sR0FBRyxNQUFNLElBQUksRUFBRSxDQUFBO1lBQ3JCLElBQUk7Z0JBQ0EsTUFBTSxJQUFJLEdBQUcsTUFBTSxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQztvQkFDbEMsTUFBTTtvQkFDTixHQUFHLEVBQUUsSUFBSTtvQkFDVCxJQUFJLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVM7b0JBQzNELE9BQU8sRUFBRSxNQUFNLENBQUMsT0FBTztvQkFDdkIsTUFBTSxFQUFFLE1BQU0sQ0FBQyxLQUFLO2lCQUN2QixDQUFDLENBQUE7Z0JBQ0YsSUFBSSxNQUFNLENBQUMsc0JBQXNCLEVBQUU7b0JBQy9CLE1BQU0sQ0FBQyxzQkFBc0IsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7aUJBQzlDO2dCQUNELE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQTthQUNuQjtZQUFDLE9BQU8sR0FBRyxFQUFFO2dCQUNWLElBQUksR0FBRyxDQUFDLFlBQVksRUFBRTtvQkFDbEIsTUFBTSxZQUFZLENBQUMsR0FBRyxDQUFDLENBQUE7aUJBQzFCO2dCQUNELE1BQU0sSUFBSSxLQUFLLENBQUMsR0FBRyxNQUFNLElBQUksYUFBTyxDQUFDLElBQUksQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLEtBQUssR0FBRyxDQUFDLE9BQU8sRUFBRSxDQUFDLENBQUE7YUFDOUU7UUFDTCxDQUFDO0tBQUE7SUFDTSxtQkFBbUIsQ0FBQyxJQUFZO1FBQ25DLE1BQU0sR0FBRyxHQUFHLGFBQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQzthQUNsQyxPQUFPLENBQUMsU0FBUyxFQUFFLEtBQUssQ0FBQzthQUN6QixPQUFPLENBQUMsVUFBVSxFQUFFLE1BQU0sQ0FBQyxDQUFBO1FBQ2hDLE9BQU8sSUFBSSwrQ0FBcUIsQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFBO0lBQ3pELENBQUM7Q0FDSjtBQTlDRCw4QkE4Q0M7QUFFRCxTQUFTLFlBQVksQ0FBQyxHQUFlO0lBQ2pDLElBQUksR0FBRyxDQUFDLFFBQVEsRUFBRTtRQUNkLE1BQU0sSUFBSSxHQUFHLEdBQUcsQ0FBQyxRQUFRLENBQUE7UUFDekIsSUFBSSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssUUFBUSxFQUFFO1lBQy9CLElBQUksSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUE7WUFDM0IsSUFBSSxJQUFJLENBQUMsTUFBTSxHQUFHLEVBQUUsRUFBRTtnQkFDbEIsSUFBSSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxHQUFHLEtBQUssQ0FBQTthQUNuQztZQUNELE9BQU8sSUFBSSxLQUFLLENBQUMsR0FBRyxJQUFJLENBQUMsTUFBTSxJQUFJLEdBQUcsQ0FBQyxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsQ0FBQyxNQUFNLENBQUMsR0FBRyxLQUFLLElBQUksRUFBRSxDQUFDLENBQUE7U0FDckY7YUFBTTtZQUNILE9BQU8sSUFBSSxLQUFLLENBQUMsR0FBRyxJQUFJLENBQUMsTUFBTSxJQUFJLEdBQUcsQ0FBQyxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsQ0FBQyxNQUFNLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQTtTQUM1RTtLQUNKO1NBQU07UUFDSCxPQUFPLElBQUksS0FBSyxDQUFDLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBQyxNQUFNLElBQUksR0FBRyxDQUFDLE1BQU0sQ0FBQyxHQUFHLEtBQUssR0FBRyxDQUFDLE9BQU8sRUFBRSxDQUFDLENBQUE7S0FDN0U7QUFDTCxDQUFDIn0=